import React from 'react';
import PropTypes from 'prop-types';

export default function VerifiedAuthor({ width = 32, height = 32, color = '#457BF9' }) {
  return (
    <svg
      role="img"
      aria-labelledby="verifiedAuthorIcon"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id="verifiedAuthorIcon">Verified Author Icon</title>
      <path
        d="M5.29337 8.049C5.29337 6.52713 6.52708 5.29341 8.04895 5.29341H23.951C25.4728 5.29341 26.7065 6.52713 26.7065 8.049V23.951C26.7065 25.4729 25.4728 26.7066 23.951 26.7066H8.04895C6.52708 26.7066 5.29337 25.4729 5.29337 23.951V8.049Z"
        fill={color}
      />
      <path
        d="M2.80709 17.9485C1.73097 16.8724 1.73097 15.1276 2.80709 14.0515L14.0515 2.80709C15.1276 1.73097 16.8724 1.73097 17.9485 2.80709L29.1929 14.0515C30.269 15.1276 30.269 16.8724 29.1929 17.9485L17.9485 29.1929C16.8724 30.269 15.1276 30.269 14.0515 29.1929L2.80709 17.9485Z"
        fill={color}
      />
      <path
        d="M21.9767 11.7427C21.6208 11.3867 21.0869 11.3867 20.731 11.7427L14.0573 18.4163L11.2988 15.6579C10.9429 15.3019 10.409 15.3019 10.0531 15.6579C9.69715 16.0138 9.69715 16.5477 10.0531 16.9036L13.4344 20.285C13.6124 20.4629 13.7903 20.5519 14.0573 20.5519C14.3242 20.5519 14.5022 20.4629 14.6802 20.285L21.9767 12.9884C22.3326 12.6325 22.3326 12.0986 21.9767 11.7427Z"
        fill="white"
      />
    </svg>
  );
}

VerifiedAuthor.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};
